import { ILivraison } from '../../interfaces/models';
import { Action } from '@ngrx/store';

export const SET = '[Livraisons] Set';
export const ADD = '[Livraisons] Add';
export const EDIT = '[Livraisons] Edit';
export const DELETE = '[Livraisons] Delete';
export const OPEN_MODAL = '[Livraisons] Open modal';
export const CLOSE_MODAL = '[Livraisons] Close modal';

export class Set implements Action {
  readonly type = SET;

  constructor(public data: ILivraison[]) {}
}

export class Add implements Action {
  readonly type = ADD;

  constructor(public data: ILivraison) {}
}

export class Edit implements Action {
  readonly type = EDIT;

  constructor(public data: ILivraison) {}
}

export class Delete implements Action {
  readonly type = DELETE;

  constructor(public id: any) {}
}

export class OpenModal implements Action {
  readonly type = OPEN_MODAL;
}

export class CloseModal implements Action {
  readonly type = CLOSE_MODAL;
}

export type All = Set | Add | Edit | Delete | OpenModal | CloseModal;
